import { get, set } from "lodash";

const CONFIG_PATH = "/config.json";

export const LONG_PRESS_DURATION = 6000;
export const configPromise = fetch(CONFIG_PATH).then(c => c.json());
export const internalStore = {};
export const store = (name: string, value: any) =>
  set(internalStore, name, value);
export const load = (name: string) => get(internalStore, name);
export const getVendorImageUrl = (vendorId: string): string =>
  `https://www.leafbuyer.com/vendors/${vendorId}/tablet-logo.png`;

export const getConfig = async (): Promise<any> =>
  await (await fetch("/config.json")).json();



// WEBPACK FOOTER //
// ./src/utils/ConfigLoader.ts